<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Reset Password</h1>
          <p>
            Please enter your new password.
          </p>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-centered">
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Password"
                            rules="required|confirmed:confirmpassword|min:8"
                          >
                            <b-field
                              label="Password"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input
                                v-model="password"
                                type="password"
                                password-reveal
                              >
                              </b-input>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Confirm Password"
                            rules="required"
                            vid="confirmpassword"
                          >
                            <b-field
                              label="Confirm Password"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input
                                v-model="confirmpassword"
                                type="password"
                                password-reveal
                              >
                              </b-input>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-text-centered">
                        <button
                          class="button is-primary btn-align no-lh raised has-margin-bottom-15"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import UserApi from '@/api/user'
export default {
  name: 'ChangePassword',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Change Password'
  },
  data() {
    return {
      loading: false,
      password: '',
      confirmpassword: ''
    }
  },
  created() {},
  methods: {
    submit() {
      this.loading = true
      UserApi.updatePassword(this.password)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Your password has been updated.',
            position: 'is-top',
            type: 'is-success'
          })
          this.loading = false
        })
        .catch(err => {
          let message = 'Error processing your request.'
          if (err && err.data) {
            switch (err.data.err) {
              case 'E_RESET_FAILED':
                message = 'Error changing your password.'
                break
            }
          }

          this.$buefy.toast.open({
            message: message,
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
